module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-instructions",
    attrs: {
      "block": "lightest"
    }
  }, [_c('h2', {
    staticClass: "h2 home-instructions__heading mt0"
  }, [_vm._v("The process is safe, simple and secure!")]), _vm._v(" "), _c('div', {
    staticClass: "home-instructions__inner group group--last"
  }, [_c('div', {
    staticClass: "home-instructions__steps"
  }, _vm._l((_vm.instructionSteps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "home-instructions__step"
    }, [_c('div', {
      staticClass: "home-instructions__icon"
    }, [_c('img', {
      attrs: {
        "src": step.image,
        "alt": step.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "home-instructions__content"
    }, [_c('h4', {
      staticClass: "home-instructions__heading h4 fw-bold"
    }, [_vm._v(_vm._s(step.heading))]), _vm._v(" "), _c('p', {
      staticClass: "p"
    }, [_vm._v(_vm._s(step.copy))])]), _vm._v(" "), (index <= _vm.instructionSteps.length - 2) ? _c('div', {
      staticClass: "home-instructions__arrow"
    }, [_c('img', {
      attrs: {
        "src": _vm.images.arrowRight,
        "alt": "Next Step"
      }
    })]) : _vm._e()])
  })), _vm._v(" "), _c('module-button', {
    staticClass: "home-instructions__button",
    attrs: {
      "button": "primary",
      "link": _vm.isAuthenticated ? "request" : "register-patient",
      "query": _vm.isAuthenticated ? {} : {
        redirect: _vm.reverseRoute("register-patient")
      },
      "size": "l",
      "label": "Start My Request"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a46ae6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Instructions.vue
// module id = 242
// module chunks = 0